import { render, staticRenderFns } from "./SourceOfFundsPage.vue?vue&type=template&id=6782b6d2"
import script from "./SourceOfFundsPage.vue?vue&type=script&lang=js"
export * from "./SourceOfFundsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports